import React from 'react';
import { BanknoteIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { currencies } from '../data/content';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const includes = ['6 tomos principales', '15 días de protocolo', "50 recetas antiinflamatorias", 'Los 5 bonos estratégicos'];
const valueRows = [{
  label: '6 tomos principales',
  value: "23,30 €"
}, {
  label: '5 bonos complementarios',
  value: "43,00 €"
}];
const assurances = [{
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: BanknoteIcon,
  label: 'Tarjeta o pago local'
}];
type OfferProps = {
  showUrgency?: boolean;
};
export function Offer({
  showUrgency = true
}: OfferProps) {
  return <section id="oferta" className="bg-white py-20 sm:py-28 space-y-[12px]" aria-labelledby="oferta-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-139" data-mp="2ad3f45at4sry">
      <div className="mx-auto max-w-5xl px-6" data-id="element-140" data-mp="pmbhhx00j86k">
        {showUrgency ? <Reveal data-id="element-141" data-mp="ui8zs8uu6olz">
            <div className="rounded-3xl bg-mint-50 px-6 py-10 sm:px-12" data-id="element-142" data-mp="uhqu6lmaay1e">
              <CountdownTimer label="COMPRANDO DENTRO DE LAS PRÓXIMAS 24 HORAS" note="Después sube el precio y no vuelve a bajar." data-id="element-143" data-mp="zjg6e4l8thr2" />
              
            </div>
          </Reveal> : null}

        <Reveal className={showUrgency ? 'mt-16' : ''} data-id="element-144" data-mp="6uinq0d4dixs">
          <div className="text-center" data-id="element-145" data-mp="6rmtam0hdce3">
            <h2 id="oferta-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-146" data-mp="bs1060qcigaj">
              Elegí tu MegaPack
            </h2>
            <p className="mt-4 text-lg text-ink-soft" data-id="element-147" data-mp="kl485ti820xs">
              Todas las opciones incluyen los 5 bonos estratégicos.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-148" data-mp="3k8doh3gm4zrw">
          <div className="mx-auto mt-12 max-w-3xl overflow-hidden rounded-3xl border border-mint-300 bg-white shadow-lift" data-id="element-149" data-mp="3oa7kgyfv5flq">
            <p className="bg-mint-600 py-2.5 text-center text-sm font-semibold uppercase tracking-[0.16em] text-white" data-id="element-150" data-mp="vez1gr9f5f1x">
              Pack completo · el más elegido
            </p>

            <div className="grid gap-10 p-8 sm:p-12 md:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)]" data-id="element-151" data-mp="155afx7qqb6n2">
              <div data-id="element-152" data-mp="106ph9cr4kv0q">
                <h3 className="font-display text-3xl text-ink" data-id="element-153" data-mp="1067ctsub7ahq">Pack Completo</h3>
                <ul className="mt-6 space-y-3" data-id="element-154" data-mp="cgcy15qfjbuu">
                  {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-155" data-mp="cippqalzp0l3">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint-600" aria-hidden="true" data-id="element-156" data-mp="7jcsqx1emd4s" />
                      <span className="text-[15px] text-ink-soft" data-id="element-157" data-mp="liw03nme5kg1">{item}</span>
                    </li>)}
                </ul>

                <dl className="mt-8 space-y-2 border-t border-mint-100 pt-6 text-sm" data-id="element-158" data-mp="hic2kixwoetd">
                  {valueRows.map(row => <div key={row.label} className="flex justify-between gap-4" data-id="element-159" data-mp="1sv4rllzbap5q">
                      <dt className="text-ink-muted" data-id="element-160" data-mp="1sx7jkbk0ysd3">{row.label}</dt>
                      <dd className="text-ink-soft" data-id="element-161" data-mp="20dufjoiylhc0">{row.value}</dd>
                    </div>)}
                  <div className="flex justify-between gap-4 font-semibold text-ink" data-id="element-162" data-mp="25ei9ahykoc9x">
                    <dt data-id="element-163" data-mp="1qhj5742xj1k7">Valor total real</dt>
                    <dd data-id="element-164" data-mp="1qikjdhf8s465">63,30 €</dd>
                  </div>
                </dl>
              </div>

              <div className="flex flex-col" data-id="element-165" data-mp="1vhncq4lv0lya">
                <p className="text-sm text-ink-muted line-through" data-id="element-166" data-mp="2j4vguj7jxoyq">63,30 €</p>
                <p className="mt-1 font-display text-6xl leading-none text-mint-700" style={{
                fontSize: "56px"
              }} data-id="element-167" data-mp="2o3ykq0bspp54">
                  18,99 €
                </p>
                <p className="mt-4 inline-flex w-fit items-center rounded-full bg-mint-100 px-3 py-1.5 text-sm font-semibold text-mint-800" data-id="element-168" data-mp="29f27louvtlxn">
                  Ahorrás 44,31 € 
                  <span className="ml-1 font-extrabold" data-id="element-169" data-mp="3237scblxraxh">
                   70% OFF!
                  </span>
                </p>

                <div className="mt-8" data-id="element-170" data-mp="36wsrw836gcys">
                  <CtaButton className="w-full" data-id="element-171" data-mp="1j6xqblyi8p3v">Quiero el Megapack</CtaButton>
                </div>

                <p className="mt-auto pt-6 text-xs leading-relaxed text-ink-muted" data-id="element-172" data-mp="1e6s0mbbspcof">
                  El precio está expresado en euros (€). No te preocupes, el cobro se realiza automáticamente en la moneda de tu país al tipo de cambio del momento.
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.04} data-id="element-173" data-mp="21wcpfaumr45m">
          <div className="mx-auto mt-10 max-w-3xl" data-id="element-174" data-mp="21yqk3ileeecn">
            
            

            <ul className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-3" data-id="element-175" data-mp="1wzw04dbp2jqy">
              {assurances.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-176" data-mp="1s4zugadjbxvd">
                  <item.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-177" data-mp="2kn3sjuo0xybk" />
                  {item.label}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}